import React, { useState } from "react";
const SIDEBAR_LIST = [
  {
    icon: "/tool/dashboard/static/images/icons/subtitle/video.svg",
    label: "From My Videos",
    selectdIcon: "/tool/dashboard/static/images/icons/subtitle/selectedVideo.svg",
  },
  {
    icon: "/tool/dashboard/static/images/icons/subtitle/upload.svg",
    label: "Upload Video",
    selectdIcon: "/tool/dashboard/static/images/icons/subtitle/selected-upload.svg",
  },
];
const SideBar = ({ selectedTab, setSelectedTab }) => {
  return (
    <div className="bg-white min-w-[205px] h-[467px] border-r-[1px] border-r-[#11142D33] ">
      <div className="px-[21px] py-4 bg-gradient-sidebar">
        <div className="flex gap-1 py-[3px] items-center">
          <img
            src="/tool/dashboard/static/images/icons/subtitle/cc.svg"
            className="w-5 h-5"
          />
          <span className="font-medium text-[#11142D] leading-[14px]">
            Subtitles
          </span>
        </div>
      </div>
      <div className="pt-[15px] pl-6 pr-5">
        <div className="flex flex-col gap-2">
          {SIDEBAR_LIST.map((item, index) => (
            <div
              className={`py-[10px] pl-3 flex gap-[6px] cursor-pointer rounded ${
                selectedTab === index ? "bg-[#11142D0D]" : ""
              }`}
              key={index}
              onClick={() => setSelectedTab(index)}
            >
              <img
                src={selectedTab === index ? item.selectdIcon : item.icon}
                className="w-5 h-5"
              />
              <span
                className={`text-sm ${
                  selectedTab === index
                    ? "font-bold text-[#6043DB]"
                    : "text-[#11142DB2] font-medium"
                }`}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SideBar;
